// get all users
export const getAllUsers = (filters) => ({
  url: "/admin/users",
  method: "GET",
  params: filters,
});

//get user availability duration
export const getUserAvailability = ({ id, filters }) => ({
  url: `/admin/user-availability/${id}`,
  method: "GET",
  params: filters,
});

// get single user
export const getSingleUser = (id) => ({
  url: `/admin/user/${id}`,
  method: "GET",
});

// toggle activation of user account
export const toggleActivation = (id) => ({
  url: `/admin/user-status/${id}`,
  method: "POST",
});

// delete user account
export const deleteUser = (id) => ({
  url: `/admin/user/${id}`,
  method: "DELETE",
});
